import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RewardRedeemConfirmationComponent} from './reward-redeem-confirmation.component';
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatFormFieldModule} from "@angular/material/form-field";
import {FormsModule} from "@angular/forms";
import {MatInputModule} from "@angular/material/input";


@NgModule({
  declarations: [
    RewardRedeemConfirmationComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule
  ],
  exports: [RewardRedeemConfirmationComponent]
})
export class RewardRedeemConfirmationModule { }
